// extracted by mini-css-extract-plugin
module.exports = {"sidebarMainLink":"sidebarnavlink_sidebarMainLink__1OU13","sidebarLinkActive":"sidebarnavlink_sidebarLinkActive__29A0B","sidebarLinkIcon":"sidebarnavlink_sidebarLinkIcon__Wp7on"};